getFirstLiveStreamSessionTS